module.exports = __webpack_public_path__ + "static/img/company-img.27a1090.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-img.webp
// module id = 3rOO
// module chunks = 1